import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-login-navigate',
  templateUrl: './login-navigate.component.html',
  styleUrls: ['./login-navigate.component.scss']
})
export class LoginNavigateComponent {
  @Input() legendas: string[];
  @Input() rotas: string[];
}
